<!--
	Unfortunately, vue-snotify has no reactive slots yet so we cannot use things such as
	TextResources or general vue components inside that update reactively. As a workaround
	we beam our components into this notification with portal-vue.
-->
<template>
	<div v-if="toast != null">
		<Teleport :to="`#${portal}`">
			<slot />
		</Teleport>
		<!-- see the comment in Button.vue -->
		<div v-show="false">
			<slot />
		</div>
	</div>
</template>
<script lang="ts">
import { Component, toNative, Prop, Vue } from "vue-facing-decorator";
import { type SnotifyToast } from "vue3-snotify";

@Component
export class Message extends Vue {
	@Prop({ required: true }) toast!: SnotifyToast | null;
	@Prop({ required: true, type: String }) portal!: string;
}

export default toNative(Message);
</script>
